
import * as video from "../../_src/components/video/"

export default function playlistModal(data) {
    video.plyr()
}
